import { useState } from "react";
import { api } from "../lib/api";
import { COMPANY, SERVICES } from "../lib/content";
import { Mail, Instagram, Facebook } from "lucide-react";
import { toast } from "sonner";

export default function ContactPage() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", service_type: SERVICES[0].title,
    budget: "", event_date: "", project_goals: "", message: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/contact", form);
      toast.success("Thank you — your message has reached the studio.");
      setForm({ name: "", email: "", phone: "", service_type: SERVICES[0].title, budget: "", event_date: "", project_goals: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-28 md:pt-40 pb-12">
        <div className="eyebrow text-[var(--crest-gold)]">— Contact</div>
        <h1 className="font-serif text-5xl md:text-7xl tracking-tight mt-6 leading-[1.02]">
          Reach the studio.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-32 grid md:grid-cols-12 gap-16">
        <div className="md:col-span-5 space-y-10">
          <div>
            <div className="eyebrow text-[var(--crest-gold)] mb-3">— Studio</div>
            <div className="font-serif text-2xl">{COMPANY.region}</div>
          </div>
          <div className="space-y-3">
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-3 hover:text-[var(--crest-gold)]" data-testid="contact-email">
              <Mail size={16} style={{ color: "var(--crest-gold)" }} /> {COMPANY.email}
            </a>
            <a href={COMPANY.instagram} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--crest-gold)]">
              <Instagram size={16} style={{ color: "var(--crest-gold)" }} /> @UCimage2
            </a>
            <a href={COMPANY.facebook} target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[var(--crest-gold)]">
              <Facebook size={16} style={{ color: "var(--crest-gold)" }} /> /ucimage2
            </a>
          </div>
          <div className="hairline" />
          <p className="text-[var(--crest-muted)] leading-relaxed">
            For media, partnership, or press inquiries — please include the nature of your request and any relevant timeline.
          </p>
        </div>

        <form onSubmit={submit} className="md:col-span-7 grid md:grid-cols-2 gap-x-10 gap-y-2" data-testid="contact-form">
          <input className="crest-input md:col-span-2" placeholder="Name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name" />
          <input type="email" className="crest-input" placeholder="Email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email-input" />
          <input className="crest-input" placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
          <select className="crest-input" value={form.service_type} onChange={(e) => setForm({ ...form, service_type: e.target.value })} data-testid="contact-service">
            {SERVICES.map((s) => <option key={s.id}>{s.title}</option>)}
          </select>
          <input className="crest-input" placeholder="Budget range" value={form.budget} onChange={(e) => setForm({ ...form, budget: e.target.value })} data-testid="contact-budget" />
          <input className="crest-input md:col-span-2" placeholder="Event / Project date(s)" value={form.event_date} onChange={(e) => setForm({ ...form, event_date: e.target.value })} data-testid="contact-event-date" />
          <input className="crest-input md:col-span-2" placeholder="Project goals (one line)" value={form.project_goals} onChange={(e) => setForm({ ...form, project_goals: e.target.value })} data-testid="contact-goals" />
          <textarea className="crest-input md:col-span-2 mt-6" placeholder="Tell us more..." required value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />
          <button className="btn-primary md:col-span-2 mt-8" disabled={submitting} data-testid="contact-submit">
            {submitting ? "Sending..." : "Send Inquiry"}
          </button>
        </form>
      </section>
    </div>
  );
}
